import { createContext } from "react";

const VideoAnnotationContext = createContext();
const VideoCompareContext = createContext();
const VideoTranscriptionContext = createContext();

export {VideoAnnotationContext, VideoCompareContext, VideoTranscriptionContext};